"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = require("react");
var enquiryForm_1 = require("../graphql/queries/enquiryForm");
var customEvent_1 = require("../../../../common/service/customEvent");
var MyAccountEvents_1 = require("../../../../common/enum/MyAccountEvents");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var useEnquiryDataLayer_1 = require("./useEnquiryDataLayer");
exports.useEnquireFormData = function (token, state) {
    var _a = client_1.useQuery(enquiryForm_1.default.GET_ENQUIRY_FORM_SCHEMA, {
        variables: {
            token: token,
            state: state,
        },
        fetchPolicy: 'cache-and-network',
    }), data = _a.data, loading = _a.loading, error = _a.error, refetch = _a.refetch;
    var deal = useCheckoutContext_1.default().deal;
    var _b = usePlatformConfig_1.default().platformConfig, dxpDataLayer = _b.dxpDataLayer, retainedFormFieldsOnRefresh = _b.platformFeatures.retainedFormFieldsOnRefresh;
    var _c = react_1.useState(null), formData = _c[0], setFormData = _c[1];
    var _d = react_1.useState(null), formSchema = _d[0], setFormSchema = _d[1];
    var _e = react_1.useState(null), uiSchema = _e[0], setUiSchema = _e[1];
    var _f = react_1.useState([]), requiredFields = _f[0], setRequiredFields = _f[1];
    var handleDataLayerChange = useEnquiryDataLayer_1.useEnquiryDataLayer(deal).handleDataLayerChange;
    var handleFormChange = react_1.useCallback(function (formData) {
        if (dxpDataLayer) {
            handleDataLayerChange({ formData: formData, formSchema: formSchema });
        }
        setFormData(formData);
    }, [formData]);
    var setRequiredFieldsOnLoad = react_1.useCallback(function (formSchema) {
        if (!formSchema) {
            return;
        }
        var required = formSchema.required || [];
        Object.values(formSchema.properties).forEach(function (item) { var _a; return (required = required.concat(((_a = item) === null || _a === void 0 ? void 0 : _a.required) || [])); });
        var requiredUpdated = required.map(function (el) { return (el === 'userIdType' ? 'identificationType' : el); });
        setRequiredFields(requiredUpdated);
    }, []);
    var hasExistingFormDataValue = function (key, formDataExistingValue) { var _a; return formDataExistingValue && ((_a = retainedFormFieldsOnRefresh) === null || _a === void 0 ? void 0 : _a.includes(key)); };
    react_1.useEffect(function () {
        var _a;
        var _b, _c, _d, _e, _f;
        if (!loading && ((_b = data) === null || _b === void 0 ? void 0 : _b.enquiryForm)) {
            var replaceNullValues = data.enquiryForm.formData.replace(/\:null/gi, ':""');
            var newJSONFormData = JSON.parse(replaceNullValues);
            var parsedSchema = JSON.parse(data.enquiryForm.schema);
            var schemaProperties = parsedSchema.properties;
            // set default value if the field has one
            for (var _i = 0, _g = Object.entries(schemaProperties); _i < _g.length; _i++) {
                var _h = _g[_i], key = _h[0], value = _h[1];
                if ('properties' in value) {
                    for (var _j = 0, _k = Object.entries(value.properties); _j < _k.length; _j++) {
                        var _l = _k[_j], propKey = _l[0], defaultValue = _l[1].default;
                        var formSection = (_c = formData) === null || _c === void 0 ? void 0 : _c[key];
                        var formDataExistingValue = formSection && formSection[propKey];
                        if (hasExistingFormDataValue(propKey, formDataExistingValue)) {
                            newJSONFormData[key] = __assign(__assign({}, (_d = newJSONFormData) === null || _d === void 0 ? void 0 : _d[key]), (_a = {}, _a[propKey] = formDataExistingValue, _a));
                        }
                        else if (((_e = newJSONFormData[key]) === null || _e === void 0 ? void 0 : _e[propKey]) === '' && defaultValue != null) {
                            newJSONFormData[key][propKey] = defaultValue;
                        }
                    }
                }
                else {
                    var formDataExistingValue = (_f = formData) === null || _f === void 0 ? void 0 : _f[key];
                    if (hasExistingFormDataValue(key, formDataExistingValue)) {
                        newJSONFormData[key] = formDataExistingValue;
                    }
                    else if (newJSONFormData[key] === '' && schemaProperties[key].default != null) {
                        newJSONFormData[key] = schemaProperties[key].default;
                    }
                }
            }
            setFormSchema(parsedSchema);
            setUiSchema(JSON.parse(data.enquiryForm.uiSchema));
            setFormData(newJSONFormData);
            setRequiredFieldsOnLoad(parsedSchema);
        }
    }, [loading]);
    var receiveMyAccountResponse = react_1.useCallback(function (_a) {
        var detail = _a.detail;
        if (detail) {
            refetch();
        }
    }, []);
    react_1.useEffect(function () {
        customEvent_1.customEvent.listen(MyAccountEvents_1.MyAccountEvents.ON_LOGIN_SUCCESS, receiveMyAccountResponse);
        return function () {
            customEvent_1.customEvent.removeListener(MyAccountEvents_1.MyAccountEvents.ON_LOGIN_SUCCESS, receiveMyAccountResponse);
        };
    }, []);
    return { formData: formData, handleFormChange: handleFormChange, formSchema: formSchema, uiSchema: uiSchema, requiredFields: requiredFields, error: error, refetch: refetch };
};
